import ReactMarkdown from "markdown-to-jsx";
import classNames from "classnames";
import React from "react";

type TextIntoProps = {
  heading: string;
  bulletPoints: {
    id: string;
    heading: string;
    paragraph?: string;
  }[];
};

const TextInto = ({ heading, bulletPoints }: TextIntoProps) => {
  return (
    <div className={"border-y-2 border-black-rock pb-[30px] pt-[24px]"}>
      <h2
        className={
          "m-auto mb-[26px] w-full max-w-[576px] text-center font-recklessBold text-[18px] leading-[130%] md:text-[26px] lg:max-w-[70%]"
        }
      >
        {heading}
      </h2>
      {bulletPoints.length > 0 && (
        <ul
          className={
            "m-auto flex max-w-[576px] flex-col gap-y-[22px] lg:mx-[125px] lg:max-w-full"
          }
        >
          {bulletPoints.map((marketingPoint, index) => {
            return (
              <li
                className={"flex flex-row gap-[10px]"}
                key={marketingPoint.id}
              >
                <div
                  className={
                    "inline-flex h-[30px] w-[30px] flex-none items-center justify-center rounded-full bg-[#C8C8CC]"
                  }
                >
                  <span className={"font-bold text-[18px] leading-[130%]"}>
                    {index + 1}
                  </span>
                </div>
                <div>
                  <p
                    className={
                      "mb-[10px] font-bold text-[16px] leading-[130%] text-mono-70 md:text-[18px]"
                    }
                  >
                    {marketingPoint.heading}
                  </p>
                  {marketingPoint.paragraph && (
                    <div
                      className={
                        "text-[16px] leading-[130%] leading-[130%] text-mono-70"
                      }
                    >
                      <ReactMarkdown
                        options={{ forceBlock: true }}
                        className={classNames(
                          "[&_p]:m-0",
                          "[&_a]:inline [&_a]:underline [&_a]:[text-underline-position:under]",
                          "focus:[&_a]:outline-none focus-visible:[&_a]:outline-none focus-visible:[&_a]:ring",
                          "[&_a]:text-cerise focus-visible:[&_a]:ring-cerise"
                        )}
                      >
                        {marketingPoint.paragraph}
                      </ReactMarkdown>
                    </div>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default TextInto;
